<main>
  <loading-overlay [isLoading]="isLoading > 0"></loading-overlay>
  <p-toast position="bottom-right" key="br"></p-toast>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ headerTitle }}</h1>
        <div class="page__title_buttons">
          <p-button [label]="'Requisition_Create' | translateWF: 'Create Requisition'" icon="pi pi-plus" (click)="viewRequisitionDetails()" />
        </div>
      </div>
    </div>

    <div class="col">
      <p-selectbutton [formControl]="selectedSection" [options]="section" optionLabel="label" optionValue="value" unselectable="true" />

      @if (selectedSection.value !== 5) {
        <!-- Original Tree Table for tabs 1-4 -->
        <div class="cs-page-list-grid">
          @if (!isExternalRequisitionsTab) {
            @if (filterConfig() && showFilters()) {
              @if (selectedSection.value === 1) {
                <csl-dynamic-filters [filterConfig]="mineAllFilterConfig()!" [state]="mineAllFilterState" />
              } @else {
                <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="minePendingFilterState" />
              }
            }

            <p-panel [header]="headerTitle">
              <ng-template pTemplate="icons">
                <p-button
                  [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
                  [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
                  (click)="showFilters.set(!showFilters())"
                  variant="outlined"
                  size="small"
                />
              </ng-template>
              <p-card data-variant="compact">
                <p-treetable
                  [value]="requisitions"
                  [lazy]="true"
                  [lazyLoadOnInit]="false"
                  (onLazyLoad)="onMineLazyLoad($event)"
                  [paginator]="true"
                  [rows]="mineRows"
                  [first]="mineFirst"
                  [totalRecords]="mineTotalRecords"
                  [rowsPerPageOptions]="rowsPerPageOptions"
                  [showCurrentPageReport]="true"
                  paginatorDropdownAppendTo="body"
                >
                  <ng-template pTemplate="header">
                    <tr class="cs-datatable-header-dark">
                      <th class="text-center">{{ 'Requisitions-Table.id' | translateWF: 'Requisition ID' }}</th>
                      <th>{{ 'Requisition_Created_By' | translateWF: 'Created By' }}</th>
                      <th>{{ 'Requisition_Assigned_User' | translateWF: 'Assigned User' }}</th>
                      <th class="text-center">
                        {{ 'Requisitions-Table.department' | translateWF: 'Department' }}
                      </th>
                      <th class="text-center">
                        {{ 'Requisitions-Table.date_created' | translateWF: 'Date Created' }}
                      </th>
                      <th class="text-center">
                        {{ 'Requisitions-Table.status' | translateWF: 'Status' }}
                      </th>
                      <th>{{ 'Requisition_Approvers' | translateWF: 'Approvers' }}</th>
                      <th class="text-center">{{ 'Actions' | translateWF: 'Actions' }}</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                    @let strictRequisition = getRequisitionStrict(rowData);
                    <tr [ttRow]="rowNode">
                      <td>
                        <p-treeTableToggler [rowNode]="rowNode" />
                        <a (click)="viewRequisitionDetails(strictRequisition.id)">{{ strictRequisition.number }}</a>
                      </td>
                      <td>{{ strictRequisition.createdByUserLite?.firstName }} {{ strictRequisition.createdByUserLite?.lastName }}</td>
                      <td>{{ strictRequisition.assignedUserLite?.firstName }} {{ strictRequisition.assignedUserLite?.lastName }}</td>
                      <td>{{ strictRequisition.departmentName }}</td>
                      <td>{{ strictRequisition.createdDate | utcToHonduras }}</td>
                      <td>{{ strictRequisition.statusName | localized }}</td>
                      <td>
                        @for (approver of strictRequisition.approvers; track $index) {
                          <div *ngIf="approver.userLite">{{ approver.userLite.firstName }} {{ approver.userLite.lastName }}</div>
                        }
                      </td>
                      <td class="text-center" (click)="downloadRequisitionPdf(strictRequisition.id!, $event)">
                        <p-button severity="secondary" icon="pi pi-print" [pTooltip]="'Requisition_Download_PDF' | translateWF: 'Download PDF'"></p-button>
                      </td>
                    </tr>
                  </ng-template>
                </p-treetable>
              </p-card>
            </p-panel>
          }
        </div>

        <!-- External Requisitions Tab (tab 5) with filters -->
        @if (isExternalRequisitionsTab) {
          <div class="cs-page-list-grid">
            @if (filterConfig() && showFilters()) {
              <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="externalFilterState" />
            }

            <p-panel [header]="headerTitle">
              <ng-template pTemplate="icons">
                <div class="row-sm-start-center">
                  <p-multiselect
                    [options]="availableColumns"
                    [(ngModel)]="selectedColumns"
                    optionLabel="label"
                    optionValue="value"
                    [placeholder]="'Requisition_Select_Columns' | translateWF: 'Select Columns'"
                    [showToggleAll]="true"
                    [maxSelectedLabels]="0"
                    [selectedItemsLabel]="'Requisition_Columns_Selected' | translateWF: '{0} column(s) selected'"
                    class="w-[16rem]"
                    size="small"
                  />
                  <p-button
                    [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
                    [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
                    (click)="showFilters.set(!showFilters())"
                    variant="outlined"
                    size="small"
                  />
                </div>
              </ng-template>
              <p-card data-variant="compact">
                <p-table
                  [value]="externalRequisitionsList()"
                  [lazy]="true"
                  [lazyLoadOnInit]="false"
                  (onLazyLoad)="onLazyLoad($event)"
                  [paginator]="true"
                  [rows]="rows"
                  [totalRecords]="totalRecords"
                  [rowsPerPageOptions]="rowsPerPageOptions"
                  paginatorDropdownAppendTo="body"
                  [showCurrentPageReport]="true"
                  [currentPageReportTemplate]="'Requisition_Showing_Entries' | translateWF: 'Showing {first} to {last} of {totalRecords} entries'"
                  selectionMode="single"
                  [scrollable]="true"
                  scrollDirection="horizontal"
                  [tableStyle]="{ 'table-layout': 'auto' }"
                  styleClass="cs-datatable-flip-scroll"
                >
                  <ng-template pTemplate="header">
                    <tr class="cs-datatable-header-dark">
                      @if (isColumnVisible('number')) {
                        <th class="whitespace-nowrap" pSortableColumn="Number">
                          {{ 'Requisition_Number' | translateWF: 'Requisition Number' }}
                          <p-sortIcon field="Number" />
                        </th>
                      }
                      @if (isColumnVisible('location')) {
                        <th class="whitespace-nowrap">{{ 'Requisition_Location' | translateWF: 'Location' }}</th>
                      }
                      @if (isColumnVisible('createdDate')) {
                        <th class="whitespace-nowrap" pSortableColumn="CreatedDate">
                          {{ 'Requisition_Date_Created' | translateWF: 'Date Created' }}
                          <p-sortIcon field="CreatedDate" />
                        </th>
                      }
                      @if (isColumnVisible('department')) {
                        <th class="whitespace-nowrap">{{ 'Requisition_Department' | translateWF: 'Department' }}</th>
                      }
                      @if (isColumnVisible('priority')) {
                        <th class="whitespace-nowrap" pSortableColumn="Priority">
                          {{ 'Requisition_Priority' | translateWF: 'Priority' }}
                          <p-sortIcon field="Priority" />
                        </th>
                      }
                      @if (isColumnVisible('status')) {
                        <th class="whitespace-nowrap" pSortableColumn="StatusReference">
                          {{ 'Requisition_Status' | translateWF: 'Status' }}
                          <p-sortIcon field="StatusReference" />
                        </th>
                      }
                      @if (isColumnVisible('issuedDate')) {
                        <th class="whitespace-nowrap" pSortableColumn="IssuedDate">
                          {{ 'Requisition_Issued_Date' | translateWF: 'Issued Date' }}
                          <p-sortIcon field="IssuedDate" />
                        </th>
                      }
                      @if (isColumnVisible('poNumbers')) {
                        <th class="whitespace-nowrap" pSortableColumn="RelatedPurchaseOrderCount">
                          {{ 'Requisition_PO_Numbers' | translateWF: 'PO Number(s)' }}
                          <p-sortIcon field="RelatedPurchaseOrderCount" />
                        </th>
                      }
                      @if (isColumnVisible('approvedItems')) {
                        <th class="whitespace-nowrap">{{ 'Requisition_Approved_Items' | translateWF: 'Approved Items' }}</th>
                      }
                      @if (isColumnVisible('type')) {
                        <th class="whitespace-nowrap">{{ 'Requisition_Type' | translateWF: 'Type' }}</th>
                      }
                      @if (isColumnVisible('category')) {
                        <th class="whitespace-nowrap">{{ 'Requisition_Category' | translateWF: 'Category' }}</th>
                      }
                      @if (isColumnVisible('assignedUser')) {
                        <th class="whitespace-nowrap" pSortableColumn="AssignUser">
                          {{ 'Requisition_Assigned_User' | translateWF: 'Assigned User' }}
                          <p-sortIcon field="AssignUser" />
                        </th>
                      }
                      @if (isColumnVisible('approvers')) {
                        <th class="whitespace-nowrap" pSortableColumn="LastApprovedAt">
                          {{ 'Requisition_Approvers' | translateWF: 'Approvers' }}
                          <p-sortIcon field="LastApprovedAt" />
                        </th>
                      }
                      @if (isColumnVisible('purchasingDone')) {
                        <th class="whitespace-nowrap" pSortableColumn="PurchasingDepartmentDone">
                          {{ 'Requisition_Purchasing_Done' | translateWF: 'Purchasing Done' }}
                          <p-sortIcon field="PurchasingDepartmentDone" />
                        </th>
                      }
                      @if (isColumnVisible('actions')) {
                        <th class="whitespace-nowrap">{{ 'Actions' | translateWF: 'Actions' }}</th>
                      }
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-rowData>
                    @let req = getRequisitionStrict(rowData);
                    <tr class="cursor-pointer" (click)="viewRequisitionDetails(req.id)">
                      @if (isColumnVisible('number')) {
                        <td class="whitespace-nowrap">
                          <a>{{ req.number }}</a>
                        </td>
                      }
                      @if (isColumnVisible('location')) {
                        <td class="whitespace-nowrap">{{ getLocationLabel(req) }}</td>
                      }
                      @if (isColumnVisible('createdDate')) {
                        <td class="whitespace-nowrap">{{ req.createdDate | utcToHonduras }}</td>
                      }
                      @if (isColumnVisible('department')) {
                        <td class="whitespace-nowrap">{{ req.departmentName || '-' }}</td>
                      }
                      @if (isColumnVisible('priority')) {
                        <td class="whitespace-nowrap">{{ getPriorityLabel(req.priority) }}</td>
                      }
                      @if (isColumnVisible('status')) {
                        <td class="whitespace-nowrap">{{ req.statusName | localized }}</td>
                      }
                      @if (isColumnVisible('issuedDate')) {
                        <td class="whitespace-nowrap">{{ req.issuedDate ? (req.issuedDate | utcToHonduras) : '-' }}</td>
                      }
                      @if (isColumnVisible('poNumbers')) {
                        <td class="whitespace-nowrap">{{ getPoNumbers(req) }}</td>
                      }
                      @if (isColumnVisible('approvedItems')) {
                        <td>
                          @if (req.entries && req.entries.length > 0) {
                            @for (entry of req.entries; track entry.lineId) {
                              @if (entry.approved) {
                                <div class="text-sm whitespace-nowrap">
                                  ({{ entry.itemCode }}) {{ entry.itemDisplayName | localized }} [{{ getUomLabel(entry.uom) }}]:
                                  {{ formatQuantity(entry.quantity) }}
                                </div>
                              }
                            }
                          } @else {
                            -
                          }
                        </td>
                      }
                      @if (isColumnVisible('type')) {
                        <td class="whitespace-nowrap">{{ getRequisitionTypeLabel(req.requisitionType) }}</td>
                      }
                      @if (isColumnVisible('category')) {
                        <td class="whitespace-nowrap">{{ getCategoryName(req) }}</td>
                      }
                      @if (isColumnVisible('assignedUser')) {
                        <td class="whitespace-nowrap">
                          @if (req.assignedUserLite) {
                            {{ req.assignedUserLite.firstName }} {{ req.assignedUserLite.lastName }}
                          } @else {
                            -
                          }
                        </td>
                      }
                      @if (isColumnVisible('approvers')) {
                        <td>
                          @if (req.approvers && req.approvers.length > 0) {
                            @for (approver of req.approvers; track $index) {
                              <div class="text-sm whitespace-nowrap">
                                @if (approver.userLite) {
                                  {{ approver.userLite.firstName }} {{ approver.userLite.lastName }}
                                } @else if (approver.username) {
                                  {{ approver.username }}
                                }
                                @if (approver.approvedAt) {
                                  <span class="text-gray-500">({{ approver.approvedAt | date: 'dd/MM/yyyy' }})</span>
                                }
                              </div>
                            }
                          } @else {
                            -
                          }
                        </td>
                      }
                      @if (isColumnVisible('purchasingDone')) {
                        <td class="whitespace-nowrap text-center">
                          @if (req.purchasingDepartmentDone) {
                            <i class="pi pi-check text-green-500"></i>
                          } @else {
                            <i class="pi pi-times text-red-400"></i>
                          }
                        </td>
                      }
                      @if (isColumnVisible('actions')) {
                        <td class="text-center" (click)="downloadRequisitionPdf(req.id!, $event)">
                          <p-button severity="secondary" icon="pi pi-print" [pTooltip]="'Requisition_Download_PDF' | translateWF: 'Download PDF'"></p-button>
                        </td>
                      }
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td [attr.colspan]="visibleColumnCount">
                        {{ 'Requisition_No_Results' | translateWF: 'No requisitions found' }}
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </p-card>
            </p-panel>
          </div>
        }
      } @else {
        <!-- Requisition Reports Content -->
        <div class="h-full w-full">
          <!-- Report: External Requisitions Approveds -->
          <h3>{{ 'External_Requisition_Report_Description' | translateWF: 'External Approved Reequisiton Report' }}</h3>
          <form [formGroup]="ExternalRequisitionReportForm">
            <div class="grid-4 gap-[1rem] items-end">
              <div class="form-box">
                <label for="From-Date">{{ 'External_Requisition_Report_From_Date' | translateWF: 'From Date' }} *</label>
                <p-datepicker
                  id="From-Date"
                  formControlName="startDate"
                  [iconDisplay]="'input'"
                  [showIcon]="true"
                  dateFormat="yy-mm-dd"
                  fluid
                  class="w-full"
                  [ngClass]="{
                    'ng-invalid ng-dirty': ExternalRequisitionReportForm.get('startDate')?.invalid && ExternalRequisitionReportForm.get('startDate')?.touched,
                  }"
                />
                <small class="p-error" *ngIf="ExternalRequisitionReportForm.get('startDate')?.invalid && ExternalRequisitionReportForm.get('startDate')?.touched">
                  {{ 'Reporting_Start_Date_Required' | translateWF: 'From date is required' }}
                </small>
              </div>

              <div class="form-box ml-2">
                <label for="knitting-movement-end">{{ 'External_Requisition_Report_To_Date' | translateWF: 'To Date' }} *</label>
                <p-datepicker
                  id="knitting-movement-end"
                  formControlName="endDate"
                  [iconDisplay]="'input'"
                  [showIcon]="true"
                  dateFormat="yy-mm-dd"
                  fluid
                  class="w-full"
                  [ngClass]="{
                    'ng-invalid ng-dirty': ExternalRequisitionReportForm.get('endDate')?.invalid && ExternalRequisitionReportForm.get('endDate')?.touched,
                  }"
                />
                <small class="p-error" *ngIf="ExternalRequisitionReportForm.get('endDate')?.invalid && ExternalRequisitionReportForm.get('endDate')?.touched">
                  {{ 'External_Requisition_Report_ToDate_Required' | translateWF: 'To date is required' }}
                </small>
              </div>

              <div class="form-box h-full items-center justify-center pt-[32px]">
                <p-button
                  [label]="'Reporting_Generate_Report' | translateWF: 'Generate Report'"
                  icon="pi pi-download"
                  (onClick)="generateExternalRequisitionReport()"
                  [outlined]="true"
                  [rounded]="true"
                  [disabled]="!ExternalRequisitionReportForm.valid"
                />
              </div>
            </div>
          </form>
        </div>
      }
    </div>
  </div>
</main>
